module.exports = "/_next/static/images/b6a3c725abc5083ca6dd02f0afdc568d-man-looking-at-phone@lg-1x.jpg";